.button {
  width: 100%;
}

.message {
  margin: 0;
}
